import React from 'react';
import CommonModal from '../../../extras/commonModal';
import { TextField } from '@material-ui/core';
import './viewRowData.css';
import RelevancyRenderer from './RelevancyRenderer';

const ViewRowData = ({
  isOpen,
  setIsOpen,
  currentRowData,
  setCurrentRowData,
  gridApi,
  handleCreateSuccess,
  setPageNumber,
  pageNumber,
}) => {
  console.log(currentRowData, 'currentRowData in ViewRowData');
  console.log(pageNumber, 'isOpen in ViewRowData');
  // const handleClose = () => {
  //   setIsOpen(false);
  //   // onGridReady();

  // };

  const disabledBlackTextStyle = {
    InputProps: {
      style: { color: '#000' },
    },
    InputLabelProps: {
      style: { color: '#000' },
    },
  };

  const handleClose = () => {
    const currentPage = gridApi.paginationGetCurrentPage();
    setIsOpen(false);
    handleCreateSuccess(currentPage);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Helper function to format array data
  const formatArrayData = (data) => {
    if (!data) return 'N/A';
    if (Array.isArray(data)) {
      return data.length > 0 ? data.join(', ') : 'Not specified';
    }
    return data;
  };

  if (!currentRowData) return null;

  return (
    <CommonModal
      isOpen={isOpen}
      setIsOpen={handleClose}
      classStyle='w-[1000px] h-auto max-h-[90vh] rounded-md'
    >
      <div className='modal-content hide-scrollbar'>
        {/* Header */}
        <div className='modal-header'>
          <h2 className='modal-title'>Job Details</h2>
          <p className='modal-subtitle'>ID: {currentRowData.id}</p>
        </div>

        {/* Job Information Grid */}
        <div className='form-grid'>
          {/* Row 1 */}
          <TextField
            label='Role Name'
            value={currentRowData.role_name || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Company Name'
            value={currentRowData.company_name || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 2 */}
          <TextField
            label='Job Location'
            value={currentRowData.job_location || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Employment Type'
            value={currentRowData.employment_type || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 3 */}
          <TextField
            label='Seniority Level'
            value={currentRowData.seniority || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Salary'
            value={currentRowData.salary || 'Not specified'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 4 */}
          <TextField
            label='Experience'
            value={formatArrayData(currentRowData.experience)}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Job Function'
            value={currentRowData.jobFunction || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 5 */}
          <TextField
            label='Industries'
            value={currentRowData.industries || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Status'
            value={currentRowData.relevant || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 6 */}
          <TextField
            label='Skills'
            value={formatArrayData(currentRowData.skills)}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Vacancy'
            value={currentRowData.vacancy || 'Not specified'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 7 */}
          <TextField
            label='Link ID'
            value={currentRowData.linkId || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Scraping Input ID'
            value={currentRowData.scraping_input_id || 'N/A'}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 8 */}
          <TextField
            label='Job Posted At'
            value={formatDate(currentRowData.job_post_at)}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Created At'
            value={formatDate(currentRowData.created_at)}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />

          {/* Row 9 */}
          <TextField
            label='Updated At'
            value={formatDate(currentRowData.updated_at)}
            disabled
            variant='outlined'
            fullWidth
            {...disabledBlackTextStyle}
          />
        </div>

        {/* Full Width Fields */}
        <div className='full-width-fields'>
          <div className='flex flex-col'>
            <label className='mb-1 text-sm text-gray-600'>Job Link</label>
            {currentRowData.job_link ? (
              <a
                href={currentRowData.job_link}
                target='_blank'
                rel='noopener noreferrer'
                className='block px-4 py-2 rounded border border-gray-300 bg-gray-100 text-blue-600 hover:underline break-all'
              >
                {currentRowData.job_link}
              </a>
            ) : (
              <div className='block px-4 py-2 rounded border border-gray-300 bg-gray-100 text-gray-500'>
                N/A
              </div>
            )}
          </div>

          <TextField
            label='Job Description'
            value={currentRowData.description || 'No description available'}
            disabled
            variant='outlined'
            fullWidth
            multiline
            rows={12}
            {...disabledBlackTextStyle}
          />

          <TextField
            label='Feedback'
            value={currentRowData.feedback || 'No feedback provided'}
            disabled
            variant='outlined'
            fullWidth
            multiline
            rows={4}
            {...disabledBlackTextStyle}
          />
        </div>
        <div className='mt-6'>
          <RelevancyRenderer
            setCurrentRowData={setCurrentRowData}
            setIsOpen={setIsOpen}
            rowId={currentRowData?.id}
            currentRowData={currentRowData}
            isOpen={isOpen}
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default ViewRowData;
